import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"

import { Button } from "components"
import KcOrderCombo from "./KcOrderCombo"
import KcOrderItem from "./KcOrderItem"
import { deliveryTypeLabels } from "constant"
import classes from "./KcOrderContents.module.scss"

const KcOrderContents = () => {
  const [t] = useTranslation()

  const history = useHistory()

  const order = useSelector(state => state.order)

  const { cinemaSolonNumber, deliveryType } =
    useSelector(state => state.deliveryInfo)

  const handleGoToDeliveryType = () => {
    history.push(
      "/kiosk-delivery-types",
      { redirectFrom: "/kiosk-checkout" }
    )
  }

  const handleGoToCinemaSolons = () => {
    history.push(
      "/kiosk-cinema-solons",
      { redirectFrom: "/kiosk-checkout" }
    )
  }

  return (
    <div className={classes["container"]}>
      <div className={classes["topbar"]}>
        <div className={classes["delivery-type"]}>
          {t("نوع_سفارش")}:

          <Button
            className={classes["button"]}
            onClick={handleGoToDeliveryType}
            color="info"
          >
            {t(deliveryTypeLabels[deliveryType])}
          </Button>
        </div>

        {
          deliveryType === "cinema" &&
          <div className={classes["delivery-type"]}>
            {t("نام سینما")}:

            <Button
              className={classes["button"]}
              onClick={handleGoToCinemaSolons}
              color="info"
            >
              {t(cinemaSolonNumber)}
            </Button>
          </div>
        }
      </div>

      <div className={classes["header"]}>
        <div className={classes["name"]}>
          {t("نام_آیتم")}
        </div>

        <div className={classes["quantity"]}>
          {t("تعداد")}
        </div>

        <div className={classes["subtotal"]}>
          {t("مجموع")}
        </div>

        <div className={classes["action"]} />
      </div>

      {order.items.map(orderItem => (
        <KcOrderItem
          key={orderItem.orderItemId}
          orderItem={orderItem}
        />
      ))}

      {order.combos.map((orderCombo, orderComboIndex) =>
        <KcOrderCombo
          key={orderComboIndex}
          orderCombo={orderCombo}
        />
      )}
    </div>
  )
}

export default KcOrderContents